import React from 'react'
import Hero from '../components/Hero'
import WhyUs from '../components/WhyUs'
import ReadMore from '../components/ReadMore'
import Steps from '../components/Steps'
const HomePage = () => {
    return (
        <div >
            <Hero />
            <WhyUs />
            <Steps />
            {/* <TinyLeadForm /> */}
            {/* <Responsibilty /> */}
            {/* <Clients /> */}
            <ReadMore links={[
                { text: 'עיצוב גרפי מיתוג ופרסום', link: '/Branding' },
                { text: 'דפוס דיגיטלי', link: '/Print' },
                { text: 'סרטוני בינה מלאכותית לעסקים', link: '/AIVideo' },
                { text: 'עריכת וידאו', link: '/VideoEditing' },
                { text: 'חבילות מיתוג', link: '/Branding#branding-packages' },
                { text: 'יצירת קשר', link: '/Contact' },
            ]} />


        </div>
    )
}

export default HomePage